var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-pagination"},[_c('div',{on:{"click":_vm.onClickPrev}},[_vm._v("⇠")]),_vm._l((_vm.totalPages),function(n){return _c('div',{key:n,class:{'active': n === _vm.currentPage},on:{"click":function($event){return _vm.onClickNPage(n)}}},[_vm._v(_vm._s(n))])}),_c('div',{on:{"click":_vm.onClickNext}},[_vm._v("⇢")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }